import { Component, Inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Order, SelectOption, BundleOrderGroupForCreation, BundleOrderGroupsRepositoryService, Bundle, OrderManagerService } from 'reg-hub-common';

@Component({
    selector: 'app-add-to-bundle',
    templateUrl: './add-to-bundle.component.html',
    styleUrl: './add-to-bundle.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddToBundleComponent implements OnInit {
  @Input() order!: Order;
  @Input() bundles!: SelectOption[];
  selectedBundleIDs: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogInut: { order: Order, bundles: SelectOption[] },
    private bundleOrdersRepo: BundleOrderGroupsRepositoryService,
    private orderManager: OrderManagerService) {
    this.order = dialogInut.order;
    this.bundles = dialogInut.bundles;
  }

  ngOnInit(): void {
  }

  addToBundle() {
    var newBundleGroup: BundleOrderGroupForCreation = {
      orderGroupID: this.order.orderGroup!.id
    };

    this.selectedBundleIDs.forEach(selectedBundleID => {
    this.bundleOrdersRepo.createBundleOrderGroup(this.order.orderGroup!.corporationID, 
      selectedBundleID!, newBundleGroup).subscribe(() => {
        var newBundle: Bundle = {
          id: selectedBundleID!,
          corporationID: this.order.orderGroup!.corporationID,
          ownerUserID: '',
          name: this.bundles.find(opt => opt.value === selectedBundleID!)?.label ?? "",
          description: "",
          added: new Date(),
          isVisible: true
        };

        this.order.orderGroup!.bundles = this.order.orderGroup!.bundles?.concat(newBundle);
        this.orderManager.updateOrder(this.order);
      })
    })
  }
}
